var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13870_84198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5684 25.9453L18.7981 3.82552C18.2227 2.82902 17.1505 2.20996 15.9997 2.20996C14.849 2.20996 13.7777 2.82902 13.2028 3.82552L0.431531 25.9443C-0.143844 26.9408 -0.143844 28.1785 0.431531 29.175C1.00691 30.1715 2.07866 30.7901 3.22891 30.7901H28.771C29.9213 30.7901 30.994 30.1715 31.5685 29.175C32.1438 28.1785 32.1438 26.9408 31.5684 25.9453ZM16.0002 27.1523C14.896 27.1523 13.9994 26.2567 13.9994 25.1521C13.9994 24.0478 14.896 23.1523 16.0002 23.1523C17.1044 23.1523 18 24.0478 18 25.1521C18 26.2568 17.1044 27.1523 16.0002 27.1523ZM17.2325 20.7507C17.2325 21.4313 16.6803 21.9825 16.0002 21.9825C15.3191 21.9825 14.7679 21.4314 14.7679 20.7507L13.9994 11.7055C13.9994 10.6007 14.896 9.70515 16.0002 9.70515C17.1044 9.70515 18 10.6008 18 11.7055L17.2325 20.7507Z",
    fill: "#F4C04B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13870_84198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.e4e2c370d3d1eed803eb54b1f07557f5.svg";
export { ForwardRef as ReactComponent };